import type { PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next';

export const UserNavItemsContainer = ({ children }: PropsWithChildren) => {
  const [t] = useTranslation('osc-header');
  return (
    <nav className="relative ms-auto flex min-h-[4.5rem]" aria-label={t('hiltonHonors')}>
      <ul className="flex">{children}</ul>
    </nav>
  );
};
